import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router'
import { UseI18n } from '../../../../common/hooks/useI18n'
import { Loading } from '../../../../common/loading'
import { Notification } from '../../../../common/notification'
import { Panel } from '../../../../common/panel'
import { panelTypes } from '../../../../common/panel/constants'
import { selectCompanyInfo } from '../../../common/header/companyInfo/store/slice'
import { BusinessStatusTable } from './BusinessStatusTable'
import { BusinessStatusPieChart } from './pieChart'
import { resetStore, selectData, selectIsLoading } from './store/slice'
import {
  exportBusinessOperatingStatus,
  getBusinessOperatingStatusTable,
} from './store/thunk'

export const BusinessOperatingStatus = () => {
  const dispatch = useDispatch()
  const location = useLocation()

  const data = useSelector(selectData)
  const locale = useSelector((state) => state.i18n.locale)
  const isLoading = useSelector(selectIsLoading)
  const { organizationShortName, organizationName, taxCode } =
    useSelector(selectCompanyInfo)
  const label = UseI18n(
    'industryOverview.businessStatus.BUSINESS_OPERATING_STATUS',
  )

  const params = new Proxy(new URLSearchParams(location.search), {
    get: (searchParam, prop) => searchParam.get(prop),
  })

  useEffect(() => {
    dispatch(
      getBusinessOperatingStatusTable({
        OrganizationId: params.organizationId,
      }),
    )
  }, [locale, params.organizationId])

  useEffect(() => {
    return () => {
      dispatch(resetStore())
    }
  }, [])

  const renderContent = () => {
    if (isLoading) {
      return (
        <div className="positionRelative h100">
          <Loading />
        </div>
      )
    }

    if (!Object.keys(data).length) {
      return <Notification />
    }

    return (
      <div className="flexColumn h100">
        <div id="businessStatusPieChartId">
          <BusinessStatusPieChart />
        </div>

        <BusinessStatusTable />
      </div>
    )
  }

  return (
    <Panel
      id="businessStatusId"
      label={label}
      height={366}
      type={panelTypes.HALF_SIZE}
      downloadJpgParams={{
        disabled: !Object.keys(data).length,
        arrName: [
          label,
          organizationShortName || organizationName || taxCode || '',
        ],
        domId: 'businessStatusPieChartId',
        titleJpg: label,
      }}
      downloadCsv={{
        disabled: !Object.keys(data).length,
        downloadFunc: () =>
          exportBusinessOperatingStatus({
            OrganizationId: params.organizationId,
          }),
      }}
    >
      {renderContent()}
    </Panel>
  )
}
